import type {CheckoutCreditPack} from '@Components/checkout-flow/checkout-flow.types';

export const CREDIT_BENEFITS_FLASH_GRAPHIC = 'credit-benefits-flash-graphic.png';

/**
 * The hand-off's gradient-masked blur cannot be expressed in CSS — Chromium does not let a mask
 * modulate backdrop-filter. These bands reproduce its ramp geometrically instead; the stylesheet
 * carries the full reasoning and the measured radii.
 */
export const PURCHASE_FOOTER_BLUR_LAYERS = ['blurLayer1', 'blurLayer2', 'blurLayer3', 'blurLayer4', 'blurLayer5', 'blurLayer6', 'blurLayer7', 'blurLayer8', 'blurLayer9', 'blurLayer10', 'blurLayer11', 'blurLayer12', 'blurLayer13', 'blurLayer14', 'blurLayer15', 'blurLayer16', 'blurLayer17', 'blurLayer18', 'blurLayer19', 'blurLayer20', 'blurLayer21', 'blurLayer22', 'blurLayer23', 'blurLayer24'] as const;

export interface CreditBenefit {
  icon: string;
  titleKey: string;
  descriptionKey: string;
  /** The hand-off paints AI features' icons with the AI content gradient and everything else in neutral. */
  isAi: boolean;
}

export interface CreditBenefitsPanelProps {
  /** Compact = the full-screen variant with its own back/close bar and purchase footer (viewports ≤ 900px). */
  isCompact: boolean;
  selectedCreditPack: CheckoutCreditPack | null;
  formattedPrice: string;
  isPurchasing: boolean;
  onBack?: () => void;
  onClose?: () => void;
  onContinue?: () => void;
}

export const getCreditBenefits = (): CreditBenefit[] => {
  return [
    {icon: 'icon-sparkle', titleKey: 'pmwjs_create_with_ai', descriptionKey: 'pmwjs_describe_what_you_want_to_create_with_simple_prompts', isAi: true},
    {icon: 'icon-remove-bg', titleKey: 'pmwjs_remove_backgrounds', descriptionKey: 'pmwjs_remove_distractions_from_images_and_videos_in_a_click', isAi: true},
    {icon: 'icon-ai-image', titleKey: 'pmwjs_ai_images_and_video', descriptionKey: 'pmwjs_describe_to_create_stunning_visuals_with_ai', isAi: true},
    {icon: 'icon-animation', titleKey: 'pmwjs_ai_animation', descriptionKey: 'pmwjs_turn_your_static_designs_into_eye_catching_videos', isAi: true},
    {icon: 'icon-ai-image-hd', titleKey: 'pmwjs_ai_upscale', descriptionKey: 'pmwjs_upscale_low_res_images_with_ai', isAi: true},
    {icon: 'icon-ai-voice', titleKey: 'pmwjs_ai_voice', descriptionKey: 'pmwjs_add_natural_sounding_voiceovers_to_your_videos_in_seconds', isAi: true},
    {icon: 'icon-magic-wand', titleKey: 'pmwjs_ai_email_redesign', descriptionKey: 'pmwjs_restyle_email_text_and_images_with_a_prompt', isAi: true},
    {icon: 'icon-mail-sends', titleKey: 'pmwjs_send_more_emails', descriptionKey: 'pmwjs_buy_more_email_sends_with_credits_when_you_run_out', isAi: false},
  ];
};
